export default {"src":"/_next/static/media/valu.4d828f5a.svg","height":26,"width":48,"blurWidth":0,"blurHeight":0};